import { InputTextProps } from "./types";
import {
  Container,
  ErrorWrapper,
  InputElement,
  InputWrapper,
  TextWrapper,
} from "./styled";
import Text from "../Text/Text";
import { FontSize } from "../../utils/Fonts";

const LABEL_DEFAULT = "Label";

const PLACEHOLDER_DEFAULT = "";

export default function Input(inputTextProps: InputTextProps) {
  const {
    value,
    placeholder,
    label,
    isRequired,
    width,
    height,
    hasError,
    messageError,
    handleChangeInput,
  } = inputTextProps;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    handleChangeInput(newValue);
  };

  const formmatedLabel = (): string => {
    if (!label) return LABEL_DEFAULT;

    if (!isRequired) return label;

    return `${label} *`;
  };

  const withError = hasError && messageError;

  return (
    <Container>
      <InputWrapper height={height} width={width}>
        {label && (
          <TextWrapper>
            <Text value={formmatedLabel()} fontSize={FontSize.TEXT_XS} />
          </TextWrapper>
        )}
        <InputElement
          height={height}
          placeholder={placeholder ?? PLACEHOLDER_DEFAULT}
          onChange={handleChange}
          value={value}
        />
      </InputWrapper>
      {withError && (
        <ErrorWrapper>
          <Text
            value={messageError}
            fontSize={FontSize.TEXT_XS}
            fontColor={"#E62231"}
          />
        </ErrorWrapper>
      )}
    </Container>
  );
}
